<template>
    <Card style="width:100%">
        <template #title>
            <Icon type="ios-link" />
            快捷阅览
        </template>
        <template #extra>
            <a href="#" @click.prevent="void">
                <Icon type="ios-loop-strong"></Icon>
                换一批
            </a>
        </template>
        <p class="rate-demo">
            <router-link to="/Blueiaas-LX5-HL101">Blueiaas-LX5-HL101</router-link>
            <span>
                <Rate count="3" disabled model="9.5" />9.5
            </span>
        </p>
        <p class="rate-demo">
            <router-link to="/Blueiaas-LX5-HS101">Blueiaas-LX5-HS101</router-link>
            <span>
                <Rate count="3" disabled model="9.5" />9.5
            </span>
        </p>
        <p class="rate-demo">
            <router-link to="/Blueiaas-LX5-HL302">Blueiaas-LX5-HL302</router-link>
            <span>
                <Rate count="3" disabled model="9.5" />9.5
            </span>
        </p>
        <p class="rate-demo">
            <router-link to="/Blueiaas-LX5-HS302">Blueiaas-LX5-HS302</router-link>
            <span>
                <Rate count="3" disabled model="9.5" />9.5
            </span>
        </p>
        <p class="rate-demo">
            <router-link to="/Blueiaas-LX5-HP302">Blueiaas-LX5-HP302</router-link>
            <span>
                <Rate count="3" disabled model="9.5" />9.5
            </span>
        </p>
        <p class="rate-demo">
            <router-link to="/Blueiaas-LX5-ML021">Blueiaas-LX5-ML021</router-link>
            <span>
                <Rate count="3" disabled model="9.5" />9.5
            </span>
        </p>
        <p class="rate-demo">
            <router-link to="/Blueiaas-LX5-ML022">Blueiaas-LX5-ML022</router-link>
            <span>
                <Rate count="3" disabled model="9.5" />9.5
            </span>
        </p>
    </Card>
</template>

<script>
export default {
  name: 'Blueiaas-sideList',
  setup() {
  },
  methods: {
    handleClick() {
      this.$Message.info('Welcome to View UI Plus Demo!')
    }
  }
}
</script>

<style lang="less" scoped>
.sec-banner{
  color: lightcoral;
  font-size: @font-size;
  margin: 0 0 20px 0;
  width: 90%;
}
.list{
  width: 90%;
}
@media (min-width: 1000px) {
  .sec-banner{
    width: 1600px;
  }
  .list{
    width: 1600px;
  }
}
</style>
